import { useEffect } from "react";

const StoveRepair = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-[#222222] text-white">
      <div className="grid grid-cols-1 md:grid-cols-2 min-h-screen">
        {/* Image container with mobile optimization */}
        <div className="h-[40vh] md:h-screen relative">
          <img
            src="/lovable-uploads/0f2976d8-1621-4d83-b761-2af0d911859a.png"
            alt="Stove repair service"
            className="w-full h-full object-cover"
          />
        </div>
        <div className="p-8 overflow-y-auto">
          <h1 className="text-4xl font-bold mb-8 text-accent">Stove Repair Services</h1>
          <div className="space-y-6">
            <section>
              <h2 className="text-2xl font-semibold text-accent-light mb-4">Professional Stove Repair in GTA</h2>
              <p className="text-gray-300 mb-4">
                We provide expert stove repair services for all types and brands. Our technicians are skilled in
                diagnosing and fixing electric stove issues quickly and efficiently.
              </p>
            </section>

            <section>
              <h3 className="text-xl font-semibold text-accent-light mb-3">Services We Provide:</h3>
              <ul className="list-disc list-inside text-gray-300 space-y-2">
                <li>Burner replacement and repair</li>
                <li>Temperature sensor calibration</li>
                <li>Control panel maintenance</li>
                <li>Heating element repairs</li>
                <li>Electronic component diagnostics</li>
              </ul>
            </section>

            <section>
              <h3 className="text-xl font-semibold text-accent-light mb-3">Our Commitment</h3>
              <ul className="space-y-4 text-gray-300">
                <li>✓ Licensed technicians</li>
                <li>✓ Rapid response</li>
                <li>✓ Quality parts</li>
                <li>✓ Fair pricing</li>
                <li>✓ Safety first approach</li>
              </ul>
            </section>

            <section>
              <h3 className="text-xl font-semibold text-accent-light mb-3">Common Stove Problems</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-gray-300">
                <div>• Burners not heating</div>
                <div>• Uneven heating</div>
                <div>• Power issues</div>
                <div>• Control malfunctions</div>
                <div>• Temperature issues</div>
                <div>• Display problems</div>
              </div>
            </section>

            <div className="mt-8">
              <a
                href="tel:416-805-5075"
                className="bg-accent hover:bg-accent-hover text-white px-6 py-3 rounded-lg inline-block transition-colors"
              >
                Call Now for Service
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StoveRepair;
